<template lang="pug">
	div(:class="{'input-item':!flat, 'with-search-icon': searchIcon}")
		.tb(:class="{'error': error}")
			img.search-icon(v-if="searchIcon" :src="`${$store.state.config.s3ResourceHost}/images/icon-search.svg`")
			label(for="" :class="{'white-label-input': isWhiteLabel}")
				span(v-if="label")
					span(v-if="error") *
					| {{label}}
				money(v-if="type == 'money'" :value="value" v-bind="moneyFormat" @input="emitInputMoney" @change="emitChange($event)" @keyup.native.enter="emitKeyup($event)" :name="name" :aria-labelledby="labelledBy" @focus="onFocus")

				input(v-else-if="type=='number'" type="number" min="minimum" max="maximum" :value="value" @change="emitChange($event)" @input="emitInput($event)" @keyup.native.enter="emitKeyup($event)" :placeholder="placeholder" @keypress="emitKeypress($event)" @focus="onFocus" :name="name" :aria-labelledby="labelledBy")

				input(v-else-if="type=='password'" type="password" :value="value" @change="emitChange($event)" @input="emitInput($event)" @keyup.native.enter="emitKeyup($event)" :placeholder="placeholder" @keypress="emitKeypress($event)" :autocomplete="autocomplete" @focus="onFocus" :name="name" :aria-labelledby="labelledBy")

				textarea(v-else-if="type == 'textarea'" type="password" :value="value" @change="emitChange($event)" @input="emitInput($event)" :placeholder="placeholder" autocomplete="new-password" ref="input" :aria-labelledby="labelledBy")

				input(v-else type="text" :value="value" @change="emitChange($event)" @input="emitInput($event)" @keyup.native.enter="emitKeyup($event)" :placeholder="placeholder" @keypress="emitKeypress($event)" :inputmode="inputmode" :autocomplete="autocomplete" @focus="onFocus" :name="name" @blur="onBlur" :aria-labelledby="labelledBy")

		span.error(v-if="error")
			| {{errorMessage}}
</template>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'

	.tb
		margin: 0
		border: 1px solid sfc-gray-dark
		&:hover
			border: 1px solid sfc-gray-dark !important
		&.error
			border: 1px solid chart-red !important

		label
			> span
				color: sfc-pale-gray
				font-size: body-font-size-xs
			&.white-label-input
				padding-right: 0 !important
				input
				textarea
					&:focus
						prudential-box-shadow()
			textarea
				border: 0
				width: 100%
				padding: 10px 20px

		textarea
		input
			color: sfc-gray-dark
			background transparent
			&::-webkit-input-placeholder
				color: text-gray-light
			&::-moz-placeholder
				color: text-gray-light
			&:-ms-input-placeholder
				color: text-gray-light
			&:-moz-placeholder
				color: text-gray-light
			&::placeholder
				color: text-gray-light

			@media(max-width: 575px)
				font-size: body-font-size-md !important

	.input-item
		.tb
			&.error
				textarea
				textarea:focus
				input:focus
				input
					border-bottom: 0 !important

		span.error
			font-size: body-font-size-xs
			color: chart-red

	.with-search-icon
		input
			padding-left: 45px !important

	.search-icon
		position: absolute
		top: 15px
		left: 15px

</style>
<script>
import {Money} from 'v-money'
export default {
	props: {
		value:{

		},
		errorMessage:{
			default: ""
		},
		error:{
			default: false
		},
		type:{

		},
		label:{

		},
		placeholder:{

		},
		searchIcon:{
			default: false
		},
		flat:{
			default: false
		},
		precision:{
			default: 0
		},
		prefix:{
			default: "$"
		},
		suffix:{
			default: ""
		},
		min:{

		},
		max:{

		},
		inputmode:{
			default: "text"
		},
		autocomplete: {
			default: "true"
		},
		scrollOnFocus: {
			default: false
		},
		scrollContainer: {
			default: undefined
		},
		name: {
			default: ""
		},
		isWhiteLabel: {
			default: false
		},
		labelledBy: {
			default: undefined
		}
	},
	components: {Money},
	data() {
		return {
			minimum: this.$props.min || -999999999999,
			maximum: this.$props.max || 999999999999,
			vmodel: "",
			moneyFormat:{
				decimal: '.',
				thousands: ',',
				prefix: this.$props.prefix == "none" ? "" : this.$props.prefix,
				suffix: this.$props.suffix,
				precision: this.$props.precision,
				masked: false /* doesn't work with directive */
			},
			lastValueSent: undefined
		}
	},
	methods: {
		emitChange(event) {
			this.$emit('change', event)
		},
		emitInput(event) {
			this.$emit('input', event.target.value)
		},
		emitKeyup(event) {
			this.$emit('keyup', event.target.value)
		},
		emitKeypress(event) {
			this.$emit('keypress', event.target.value)
		},
		emitInputMoney(value) {
			if(value == this.lastValueSent){
				return
			}else{
				this.lastValueSent = value
				this.$emit('input', value)
			}

		},
		onFocus(event){
			this.$emit('focus')
			if(!this.scrollOnFocus || !this.scrollContainer) return
			setTimeout(() => {
				document.querySelector(this.scrollContainer).scrollTop += event.target.getBoundingClientRect().top-20
			}, 300)
		},
		onBlur(event){
			this.$emit('blur')
		}
	}
}
</script>
